document.addEventListener("DOMContentLoaded", function() {  
  var swiper = new Swiper(".swiper-categories", {
    slidesPerView: 'auto',
    spaceBetween: 20,
    breakpoints: {
      320: {
        slidesPerView: 2.2,
        height: 300,
      },
      768: {
        slidesPerView: 4,
      },
    },
    navigation: {
      nextEl: '#men-categories-list .swiper-button-next',
      prevEl: '#men-categories-list .swiper-button-prev',
    },
  });

  var swiper = new Swiper(".swiper-popular-picks", {
    slidesPerView: 'auto',
    spaceBetween: 20,
    breakpoints: {
      320: {
        slidesPerView: 2.2,
        height: 300,
      },
      768: {
        slidesPerView: 4,
      },
    },
    navigation: {
      nextEl: '#popular-picks .swiper-button-next',
      prevEl: '#popular-picks .swiper-button-prev',
    },
  });

  // start
  $(document).ready(function () {
    
    setTimeout(function () {
      generateRatingWithRetry();
    }, 1000);
  });


  let ratingsGenerated = false;
  
  
  function generateRatingWithRetry(attempts = 5) {
    const maxStars = 5;
  
    const starsContainers = document.getElementsByClassName("stars-container2");
    const ratingTexts = document.getElementsByClassName("rating-text2");
  
    
    if (starsContainers.length === 0 || ratingTexts.length === 0) {
      if (attempts > 0) {
        
        setTimeout(() => {
          generateRatingWithRetry(attempts - 1);
        }, 500);
      } else {
        console.warn("Elements not found after multiple attempts.");
      }
      return; 
    }
  
    
    if (ratingsGenerated) {
      console.log("Ratings have already been generated. Skipping.");
      return; 
    }
  
   
    for (let index = 0; index < starsContainers.length; index++) {
      const starsContainer = starsContainers[index];
      const ratingText = ratingTexts[index];
  
      if (starsContainer && ratingText) {
        
        const randomFilledStars = Math.floor(Math.random() * 2) + 4; 
        const randomRatingsCount = Math.floor(Math.random() * 401) + 100; 
  
        starsContainer.innerHTML = ""; 
  
        
        for (let i = 1; i <= maxStars; i++) {
          const star = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "svg"
          );
          star.setAttribute(
            "class",
            i <= randomFilledStars ? "star full" : "star empty"
          );
          star.setAttribute("viewBox", "0 0 24 24");
          star.setAttribute("width", "15");
          star.setAttribute("height", "14.47");
  
          const path = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "path"
          );
          path.setAttribute(
            "d",
            "M12 2L15 9h8l-6 5 2 8-7-4.5L4 22l2-8L0 9h8L12 2z"
          );
  
          if (i > randomFilledStars) {
            path.setAttribute("fill", "none");
            path.setAttribute("stroke", "#F4C150");
            path.setAttribute("stroke-width", "2");
          }
  
          star.appendChild(path);
          starsContainer.appendChild(star);
        }
  
        
        ratingText.textContent = `${randomFilledStars}/${maxStars}`;
      }
    }
  
    
    ratingsGenerated = true;
  }


  function observeSnippetChanges() {
    const ratingContainer = document.querySelector("#popular-picks");
    generateRatingWithRetry();
  
    if (!ratingContainer) {
      console.warn("Rating container not found!");
      return;
    }
  
  
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "childList" || mutation.type === "subtree") {
          generateRatingWithRetry();
        }
      });
    });
  
    
    observer.observe(ratingContainer, { childList: true, subtree: true });
  }


  observeSnippetChanges(); // end


  document.addEventListener('DOMContentLoaded', function () {
    const dropdownTriggers = document.querySelectorAll('.site-nav__link--has-dropdown');
  
    dropdownTriggers.forEach(link => {
      link.addEventListener('click', function (e) {
        // Prevent default navigation only on large screens
        if (window.innerWidth > 992) {
          e.preventDefault();
          const parentItem = link.closest('.site-nav__item');
          parentItem.classList.toggle('open');
        }
      });
    });
  });


  function matchHeight() {
    var first = $('#main-content2 .col-12.col-md-6').eq(0);
    var second = $('#main-content2 .col-12.col-md-6').eq(1);
    
    second.height('auto'); // reset height
    second.height(first.outerHeight());
  }
  
  $(window).on('resize', matchHeight);
  $(window).on('load', matchHeight);

  function setBoxHeightVariable() {
    const navBtnsSelector = '.swiper-has-navs.dynamic-navs .cards-swiper-wrap .swiper-button-next, .swiper-has-navs.dynamic-navs .cards-swiper-wrap .swiper-button-prev';
    const swiperWrapSelector = '.swiper-has-navs.dynamic-navs .cards-swiper-wrap';
    const height = $(swiperWrapSelector).outerHeight();
    $(navBtnsSelector).css({top: (height/2 + 14) + 'px'});
  }
  
  // Call it once and on resize if needed
  setBoxHeightVariable();
  $(window).on('resize', setBoxHeightVariable);
  $(window).on('load', setBoxHeightVariable);

  // position swiper nav btns - start
  function positionSwiperNavButtons() {
    const firstSlideImage = document.querySelector('#popular-picks .swiper-slide .cc-card-body img');
  
    if (!firstSlideImage || !firstSlideImage.complete) {
      // Wait for image to load if not ready
      firstSlideImage?.addEventListener('load', positionSwiperNavButtons);
      return;
    }
  
    const imageHeight = document.querySelector('#popular-picks .swiper-slide .cc-card-body').clientHeight;
    const buttonTop = imageHeight / 2;
  
    const nextBtn = document.querySelector('#popular-picks .swiper-button-next');
    const prevBtn = document.querySelector('#popular-picks .swiper-button-prev');
  
    if (nextBtn && prevBtn) {
      nextBtn.style.top = `${buttonTop}px`;
      prevBtn.style.top = `${buttonTop}px`;
    }
  }
  
  // Run on load and resize
  window.addEventListener('load', positionSwiperNavButtons);
  window.addEventListener('resize', positionSwiperNavButtons);
  setTimeout(positionSwiperNavButtons, 200);
  // position swiper nav btns - end
  
});
